import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// Packages
import { Button, Card, Col, Container, Row } from 'react-bootstrap';

// Components
import GroupForm from '../groups/GroupForm';
import FieldsForm from '../fields/FieldsForm';
import Fields from '../fields/Fields';
import ToastAlert from '../../../utils/ToastAlert';

// Actions
import { get_global_config_groups, get_global_config_info, global_config_groups_changes } from '../../../../actions/globalActions';

// Utils
import isEmpty from '../../../../utils/isEmpty';
import errorExists from '../../../../utils/errorExists';

const GlobalConfigInfo = () => {
	const { config_id } = useParams();

	const dispatch = useDispatch();

	const { global_config_info, global_config_groups_loading, global_config_groups, global_errors } = useSelector(state => state.global);

	const [globalConfigGroupsFilters, setGlobalConfigGroupsFilters] = useState({})
	const [showGroupModal, setShowGroupModal] = useState(false);
	const [showFieldModal, setShowFieldModal] = useState(false);
	const [update, setUpdate] = useState(false);
	const [fieldToUpdate, setFieldToUpdate] = useState({});

	useEffect(() => {
		dispatch(get_global_config_info(config_id));
	}, []);

	useEffect(() => {
		if (!isEmpty(global_config_info)) {
			const filters = {
				organization: global_config_info?.organization?._id?.$oid,
				app: global_config_info?.app?._id?.$oid,
				language: global_config_info?.language?._id?.$oid,
				skip: 0,
				limit: 0
			}
			setGlobalConfigGroupsFilters(filters);
			dispatch(get_global_config_groups(filters));
		}
	}, [global_config_info]);

	useEffect(() => {
		if (global_config_groups.count !== 0) {
			global_config_groups.groups.forEach(group => {
				dispatch(global_config_groups_changes(group._id.$oid, false));
			});
		}
	}, [global_config_groups]);	

	const createGroup = () => {
		setShowGroupModal(true);
	}

	const onHideGroupModal = () => {
		setShowGroupModal(false);
	}

	const createField = () => {
		setUpdate(false);
		setShowFieldModal(true);
		setFieldToUpdate({});
	}

	const onHide = () => {
		setShowFieldModal(false);
		setFieldToUpdate({});
	}
	
	return (
		<Container className='mt-3 custom-p-container'>
			<ToastAlert />

			<GroupForm
				show={showGroupModal}
				onHide={onHideGroupModal}
				filters={globalConfigGroupsFilters}
			/>

			<FieldsForm
				show={showFieldModal}
				onHide={onHide}
				filters={globalConfigGroupsFilters}
				update={update}
				fieldToUpdate={fieldToUpdate}
			/>

			<h2 className='text-center'>Global Configuration Information</h2>
			<p className='text-center text-muted'><strong>Id:</strong> {global_config_info?._id?.$oid}</p>

			<Card className='shadow mb-5 bg-body rounded card-border'>
				<Card.Body>
					<Container className='p-0'>
						<Row>
							<Col className='text-center'>
								<p className='m-0'><strong>Organization:</strong> {global_config_info?.organization?.name}</p>
								<p className='m-0 text-muted'><strong>Id:</strong> {global_config_info?.organization?._id?.$oid}</p>
							</Col>
							<Col className='text-center'>
								<p className='m-0'><strong>App:</strong> {global_config_info?.app?.name}</p>
								<p className='m-0 text-muted'><strong>Id:</strong> {global_config_info?.app?._id?.$oid}</p>
							</Col>
							<Col className='text-center'>
								<p className='m-0'><strong>Language:</strong> {global_config_info?.language?.name}</p>
								<p className='m-0 text-muted'><strong>Id:</strong> {global_config_info?.language?._id?.$oid}</p>
							</Col>
						</Row>
					</Container>
				</Card.Body>
			</Card>

			{global_config_groups_loading
				?	<p className='text-center'><em>Loading...</em></p>
				:	errorExists(global_errors, 'global_config_groups') && <p className='text-center'><em>No groups found</em></p>
			}
			{!global_config_groups_loading && global_config_groups.count > 0 &&
				global_config_groups.groups.map((group, index) => (
					<Card key={index} className='shadow mb-5 bg-body rounded card-border'>
						<Card.Body>
							<Card.Title className='text-center' as='h5'>{group.label}</Card.Title>
							<Card.Subtitle className='mb-2 text-center text-muted' as='p'><strong>Id:</strong> {group._id?.$oid}</Card.Subtitle>
							<hr />
							<Container className='p-0'>
								<Row>
									<Col className='text-center'><strong>Name:</strong> {group.name}</Col>
									<Col className='text-center'><strong>Description:</strong> {group.description}</Col>
								</Row>
							</Container>
							<Fields
								groupId={group._id.$oid}
								filters={globalConfigGroupsFilters}
								showFieldModal={showFieldModal}
								setShowFieldModal={setShowFieldModal}
								update={update}
								setUpdate={setUpdate}
								fieldToUpdate={fieldToUpdate}
								setFieldToUpdate={setFieldToUpdate}
							/>
						</Card.Body>
					</Card>
				))
			}

			{!global_config_groups_loading && global_config_groups.count === 0 &&
				<Fields
					groupId={null}
					filters={globalConfigGroupsFilters}
					showFieldModal={showFieldModal}
					setShowFieldModal={setShowFieldModal}
					update={update}
					setUpdate={setUpdate}
					fieldToUpdate={fieldToUpdate}
					setFieldToUpdate={setFieldToUpdate}
				/>
			}

			<Row className='d-flex justify-content-center py-3'>
				<Col>
					<div className='d-grid gap-2'>
						<Button className='submit-btn' onClick={createGroup}>
							Add Group
						</Button>
					</div>
				</Col>
				{!global_config_groups_loading && global_config_groups.count === 0 &&
					<Col>
						<div className='d-grid gap-2'>
							<Button className='submit-btn' onClick={createField}>
								Add Field
							</Button>
						</div>
					</Col>
				}
			</Row>
		</Container>
	)
}

export default GlobalConfigInfo;
